import angular from 'angular'

import VdIdBadgeTitle from './vd-id-badge-title.component'

angular.module('vend.ui').component('vdIdBadgeTitle', VdIdBadgeTitle)
